var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 91,
    viewBox: "0 0 89 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 44C89 68.8528 68.8528 91 44 91C19.1472 91 0.5 74.3528 0.5 49.5C0.5 24.6472 24.6472 0 49.5 0C74.3528 0 89 19.1472 89 44Z",
    fill: "#2E68DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2644 58.9349V38.7366H28.4046V58.9349H35.265H35.2644ZM31.8357 35.9794C34.2274 35.9794 35.7163 34.4283 35.7163 32.49C35.6714 30.5077 34.2274 29 31.8812 29C29.5333 29 28 30.5077 28 32.49C28 34.4283 29.4884 35.9794 31.7907 35.9794H31.8351H31.8357ZM39.0611 58.9349H45.9202V47.6566C45.9202 47.0535 45.9652 46.4493 46.1462 46.0187C46.6419 44.8119 47.7707 43.563 49.666 43.563C52.1476 43.563 53.1408 45.415 53.1408 48.1306V58.9349H60V47.3539C60 41.1501 56.6163 38.2632 52.1032 38.2632C48.403 38.2632 46.778 40.2871 45.8753 41.6657H45.9208V38.7372H39.0617C39.151 40.6321 39.0611 58.9355 39.0611 58.9355V58.9349Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.28f41d9b8f528c06034d2a99cbdada73.svg";
export { ForwardRef as ReactComponent };